import React, { Component } from "react";
import { Link } from "react-router-dom";

import { Translate } from "react-redux-i18n";

import "../../styles/components/static/NotFound.scss";
import evio_o_black from "../../styles/images/evio_o_black.svg";

class NotFound extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div id="notFound">
        <img src={evio_o_black} alt="" />
        <div className="text-container">
          <Translate value="notFound_error404" />
          <Link to="/site-ceme" href="/site-ceme" className="link">
            <Translate value="notFound_return" />
          </Link>
        </div>
      </div>
    );
  }
}

export default NotFound;
